module.exports = __webpack_public_path__ + "32442424d86d7e36d7c19a88e8096a09.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/onboarding/examples-2.png
// module id = 1685
// module chunks = 0